<div
  class="touareg-control-state-layout sidebar w-100 h-100"
  [ngClass]="{ locked: locked }"
>
  <!-- MODE SHOW -->
  <!-- Le state est masqué -->
  <ng-container *ngIf="noShow; else showState">
    <div class="position-relative w-100 h-100 d-flex flex-center">
      <div class="mt-4">{{ noShowMessage }}</div>
      <app-overlay></app-overlay>
    </div>
  </ng-container>

  <!-- MODE SHOW -->
  <ng-template #showState>
    <div class="central-bar w-100 row">
      <!-- Liste de suggestions -->
      <div class="zone-left suggestion">
        <div class="list-wrapper">
          <div class="list-label">
            {{ 'touareg.suggestion' | translate }}
          </div>
          <div class="list">
            <div class="box" *ngFor="let item of suggestionLocalList">
              <app-touareg-control-state-row
                (action)="selectTag(item)"
                (openInfo)="onOpenTagInfo($event)"
                (closeInfo)="onCloseTagInfo($event)"
                [computedRecord]="item"
                [showAction]="showActions"
                [settings]="settings"
                [open]="opens[item.record.tag_uid]"
                zone="left"
              ></app-touareg-control-state-row>
            </div>
          </div>
          <!-- Locked overlay -->
          <!-- <div *ngIf="locked" class="lock"></div> -->
          <!-- Loading overlay -->
          <app-overlay *ngIf="loading" class="loading"></app-overlay>
        </div>
      </div>

      <!-- Liste de sélection -->
      <div class="zone-middle selection">
        <div class="list-wrapper">
          <div class="list-label">
            {{ 'touareg.loaded' | translate }}
          </div>
          <div class="list">
            <app-touareg-control-search
              *ngIf="showSearch"
              class="box"
              (select)="onAdd($event)"
            ></app-touareg-control-search>
            <div class="box" *ngFor="let item of selectionLocalList">
              <app-touareg-control-state-row
                (action)="rejectTag(item)"
                (openInfo)="onOpenTagInfo($event)"
                (closeInfo)="onCloseTagInfo($event)"
                [computedRecord]="item"
                [showAction]="showActions"
                [settings]="settings"
                [open]="opens[item.record.tag_uid]"
                zone="right"
              ></app-touareg-control-state-row>
            </div>
          </div>
          <!--  Button central -->
          <div *ngIf="centralButton" class="central-button d-flex flex-column">
            <button
              *ngIf="!!suggestionLocalList.length"
              mat-fab
              class="white central-button-right"
              (click)="onSelectAll($event)"
            >
              <mat-icon>double_arrow</mat-icon>
            </button>
            <button
              mat-fab
              class="white central-button-left"
              *ngIf="!!selectionLocalList.length"
              (click)="deSelectAll($event)"
            >
              <mat-icon class="central-button-left-rotate"
                >double_arrow</mat-icon
              >
            </button>
          </div>
          <!-- Locked overlay -->
          <!-- <div *ngIf="locked" class="lock"></div> -->
          <!-- Loading overlay -->
          <app-overlay *ngIf="loading" class="loading"></app-overlay>
        </div>
      </div>

      <!-- Zone informative -->
      <div class="zone-right pickstate">
        <div class="w-100 h-100">
          <div class="info-assets">
            <app-touareg-control-state-assets
              [state]="currentState!"
            ></app-touareg-control-state-assets>
          </div>
          <div class="info-states">
            <app-touareg-control-state-info
              [state]="currentState!"
              [message]="message!"
            ></app-touareg-control-state-info>
          </div>
        </div>
      </div>

      <!-- Zone de message d'attente en overlay -->
      <div *ngIf="waiting" class="state-message">
        <div class="inner">
          <div
            class="forklift-icons d-flex align-items-center justify-content-center mb-1"
          >
            <mat-icon
              class="fs forklift-mini mr-05"
              svgIcon="forklift-mini"
            ></mat-icon>
            <mat-icon>fast_forward</mat-icon>
          </div>
          <p class="text-1-5">
            {{ 'touareg.approchBoxStartAutomaticScan' | translate }}
          </p>
        </div>
      </div>

      <!-- Zone d'erreur en overlay -->
      <div *ngIf="error" class="state-error">
        <div class="inner">
          <p>{{ error }}</p>
        </div>
      </div>

      <!-- Zone de countdown en overlay -->
      <div *ngIf="showCountdown" class="state-countdown">
        <div class="inner">
          <app-touareg-control-progress-countdown
            [state]="currentState!"
            [text]="countdownMessage"
          ></app-touareg-control-progress-countdown>
        </div>
      </div>
    </div>

    <!-- Zone action bar -->
    <div class="action-bar position-relative w-100 row">
      <div class="zone-left">
        <div class="action-zone-inner">
          <ng-content select="[slot-left]"></ng-content>
        </div>
      </div>
      <div class="zone-middle">
        <div class="action-zone-inner">
          <ng-content select="[slot-middle]"></ng-content>
        </div>
      </div>
      <div class="zone-right">
        <div class="action-zone-inner">
          <ng-content select="[slot-right]"></ng-content>
        </div>
      </div>
    </div>
  </ng-template>
</div>
